import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b306af1e&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b306af1e')) {
      api.createRecord('b306af1e', component.options)
    } else {
      api.reload('b306af1e', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b306af1e&", function () {
      api.rerender('b306af1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4H4CWVCAKegFN/JS/comp/FavElement.vue"
export default component.exports